module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 min-h-screen"
  }, [(_vm.isMovil) ? _c('div', {
    staticClass: "p-2"
  }, [_c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "div",
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      on: {
        "click": function($event) {
          item.showFull = !item.showFull
        }
      }
    }, [(index === 0 || item.fechaString !== _vm.lista[index - 1].fechaString) ? _c('div', {
      staticClass: "flex justify-center mb-2"
    }, [_c('span', {
      staticClass: "text-xxs rounded-full px-3 bg-primary text-white p-1 rounded leading-none"
    }, [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fecha)))])]) : _vm._e(), _c('div', {
      staticClass: "p-4 bg-white rounded-lg shadow-xs relative"
    }, [_c('div', {
      staticClass: "absolute top-0 right-0 mt-1 mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.irAGasto(item._id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit text-gray-500"
    })]), (item.moneda === 'soles') ? _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v("S/")]) : _vm._e(), (item.moneda === 'dolares') ? _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v("$")]) : _vm._e(), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(_vm._f("twoDecimals")(item.monto)))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" en ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionTipoGasto))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showFull),
        expression: "item.showFull"
      }]
    }, [_c('div', {
      staticClass: "flex text-xs mt-4"
    }, [_c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreEmpleado))])])]), (item.comentario) ? _c('div', {
      staticClass: "mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
    }, [_vm._v(_vm._s(item.comentario))]) : _vm._e()])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "filtros flex mt-2"
  }, [_c('div', {
    key: "tipo-gasto",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo gasto")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoGasto),
      expression: "descripcionTipoGasto"
    }],
    ref: "tipoGasto",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoGasto)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoGasto = $event.target.value
      }
    }
  }), _vm._m(0), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoGasto) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoGasto = false
      }
    }
  }, [_c('tipo-gasto-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoGasto,
      "close": _vm.cerrarTipoGasto
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "empleado",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Empleado")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEmpleado),
      expression: "nombreEmpleado"
    }],
    ref: "empleado",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico' || _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEmpleado)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEmpleado = true
      }],
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEmpleado = $event.target.value
      }
    }
  }), _vm._m(1), (_vm.perfil !== 'tecnico' && _vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEmpleado) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEmpleado = false
      }
    }
  }, [_c('empleado-seleccionar', {
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": _vm.cerrarEmpleado
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "fechaDesde",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha desde")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaDesde),
      expression: "fechaDesde"
    }],
    ref: "fechaDesde",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaDesde = $event.target.value
      }
    }
  }), _vm._m(2)])])]), _c('div', {
    key: "fechaHasta",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha hasta")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaHasta),
      expression: "fechaHasta"
    }],
    ref: "fechaHasta",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date",
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.fechaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaHasta = $event.target.value
      }
    }
  }), _vm._m(3)])])]), _c('div', {
    key: "buttons",
    staticClass: "flex mb-2 p-2 flex-col text-xs"
  }, [_c('button', {
    staticClass: "text-primary border-primary border font-bold py-1 px-2 rounded cursor-pointer",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("Refrescar")]), _c('button', {
    staticClass: "mt-1 bg-primary text-white font-bold py-1 px-2 rounded cursor-pointer",
    attrs: {
      "disabled": _vm.isLoadingExcel
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("Exportar excel")])])]), _c('table', {
    staticClass: "w-full"
  }, [_c('thead', {
    staticClass: "sticky top-0"
  }, [_c('tr', {
    staticClass: "sticky top-0"
  }, [_c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fecha')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha")]), (_vm.sortByName === 'fecha') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreEmpleado')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Empleado")]), (_vm.sortByName === 'nombreEmpleado') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionTipoGasto')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo Gasto")]), (_vm.sortByName === 'descripcionTipoGasto') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('moneda')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Moneda")]), (_vm.sortByName === 'moneda') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('monto')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Monto")]), (_vm.sortByName === 'monto') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _vm._m(4), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaCreacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Creación")]), (_vm.sortByName === 'fechaCreacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaModificacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Modificación")]), (_vm.sortByName === 'fechaModificacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])])])]), _c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "tbody",
    staticClass: "text-xs",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: index + 1,
      ref: "task",
      refInFor: true,
      staticClass: "hover:bg-gray-100",
      on: {
        "dblclick": function($event) {
          return _vm.irAGasto(item._id)
        },
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.openMenu(item, index)
        }
      }
    }, [_c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.fechaString))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreEmpleado))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionTipoGasto))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.moneda))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-right"
    }, [_vm._v(_vm._s(_vm._f("twoDecimals")(item.monto)))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.comentario))]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaCreacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaCreacion)))])])]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaModificacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaModificacion)))])])])])
  }), 0)], 1)]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "m-2 mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
  }, [_vm._v("No existe ningún gasto registrado.")]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading flex items-center justify-center text-primary text-xl"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e(), _c('div', {
    staticClass: "fixed bottom-0 right-0 padding-floating-button"
  }, [_c('div', {
    staticClass: "flex justify-center items-center p-0 w-10 h-10 bg-primary rounded-full mouse shadow text-white",
    on: {
      "click": _vm.nuevoGasto
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-funnel-dollar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Comentario")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11a9b1f8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/v_gasto_list.vue
// module id = 228
// module chunks = 1